import { UseQueryOptions, useMutation, useQuery } from 'react-query';
import http, { createFetchAPI, handleApiError } from '../http';

const fetchFormFieldsEndpoint = '/v1/manual_refunds/form_fields';
export const manualRefundCacheKey = 'manual_refunds_form_fields';

export type ManualRefundFormFieldsResponseType = {
  payment_type_details: {
    [key: string]: {
      identifier: string;
      name: string;
      optional: boolean;
      type: string;
    }[];
  };
};

const fetchManualRefundFormFields = createFetchAPI<
  {},
  ManualRefundFormFieldsResponseType
>(fetchFormFieldsEndpoint);

export const useFetchManualRefundFormFields = (
  options?: UseQueryOptions<ManualRefundFormFieldsResponseType, unknown>,
) =>
  useQuery<ManualRefundFormFieldsResponseType>(
    [manualRefundCacheKey],
    fetchManualRefundFormFields,
    { ...options },
  );

const manualRefundEndpoint = '/v1/manual_refunds/refund';

type ManualRefundPayload = {
  payment_type: string;
  [k: string]: string | Record<string, string> | undefined;
};

const manualRefund = <T = ManualRefundPayload>(payload: T) =>
  http.post<T>(manualRefundEndpoint, payload);

export function useManualRefundMutation() {
  return useMutation(
    async (payload: ManualRefundPayload) => manualRefund(payload),
    {
      onError: handleApiError,
    },
  );
}
